import { countryDataAttribute, languageDataAttribute, useDataAttributes } from '../config/script-attributes'

const DATA_ATTRIBUTES_ENABLED = 'true'
const JAPAN_LANGUAGE = 'ja'
const JAPAN_COUNTRY = 'jp'

/** Honorific appended to the user's first name on Japanese sites (e.g. 太郎さん). */
export const JAPANESE_NAME_HONORIFIC = 'さん'

const normalize = (value: string | null | undefined): string =>
	String(value ?? '')
		.trim()
		.toLowerCase()

/**
 * Returns true on Japanese sites, where names are written family name first and addressed with an honorific.
 * A site is Japanese when data attributes are enabled and the script's data-language is "ja" or its
 * data-country is "jp", or when the nav bundle uses a Japan nav config (region "JP").
 */
export function isJapanSite(): boolean {
	const japanDataAttributes =
		useDataAttributes === DATA_ATTRIBUTES_ENABLED &&
		(normalize(languageDataAttribute) === JAPAN_LANGUAGE || normalize(countryDataAttribute) === JAPAN_COUNTRY)

	return japanDataAttributes || normalize(window.gbpe?.config?.region) === JAPAN_COUNTRY
}

/**
 * Builds the two-character avatar initials from the profile name.
 * @returns First + Family initials (e.g. "JD"), or Family + First on Japanese sites (e.g. "山太")
 */
export function getProfileInitials(firstName: string, lastName: string): string {
	const firstInitial = String(firstName).charAt(0)
	const lastInitial = String(lastName).charAt(0)
	return isJapanSite() ? lastInitial + firstInitial : firstInitial + lastInitial
}

/**
 * Builds the visible profile name shown next to the avatar.
 * @returns The first name, with the Japanese honorific appended on Japanese sites (e.g. "太郎さん")
 */
export function getProfileDisplayName(firstName: string): string {
	return isJapanSite() ? `${firstName}${JAPANESE_NAME_HONORIFIC}` : firstName
}
